/* tslint:disable */
export var icon = "\n<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 11v-1H6.957l3.793-3.75L10 5.5l-5 5.043 5 4.957.75-.75L6.872 11z\" fill-rule=\"nonzero\"/></svg>\n";
//# sourceMappingURL=arrow-prev.svg.js.map